import React, { useState, useEffect } from 'react';
import { useAppContext } from '../context/appContext';
import TokenService from '../utils/TokenService';
import MainMenu from '../components/MainMenu';
import { classNames } from 'primereact/utils';
import { Avatar } from 'primereact/avatar';

const Logout = () => {
    const { logoutUser } = useAppContext();
    const [countdown, setCountdown] = useState(4);
    const [redirectUrl, setRedirectUrl] = useState(null);
    const [listeningForMessages, setListeningForMessages] = useState(false);
    const [loggedOutNetworkUi, setLoggedOutNetworkUi] = useState(false);
    const [loggedOutProviderUi, setLoggedOutProviderUi] = useState(false);
    const [loggedOutIdUi, setLoggedOutIdUi] = useState(false);
    const [loggedOutComplete, setLoggedOutComplete] = useState(false);

    useEffect(() => {
        const startTime = Date.now();

        const handleMessage = (event) => {
            if (event.data && event.data.type === 'wallistNetworkUi:providerLogoutComplete') {
                const elapsed = Date.now() - startTime;
                console.log(`Logout from network UI took ${elapsed} ms`);
                setLoggedOutNetworkUi(true);
            }
            if (event.data && event.data.type === 'wallistProviderUi:providerLogoutComplete') {
                const elapsed = Date.now() - startTime;
                console.log(`Logout from provider UI took ${elapsed} ms`);
                setLoggedOutProviderUi(true);
            }
        };

        const firstFunction = async () => {
            await logoutUser();
            setLoggedOutIdUi(true);
        };

        const secondFunction = async () => {
            await firstFunction();
            let _redirectUrl = TokenService.getRedirectOnLogout();
            TokenService.removeRedirectOnLogout();
            if (!_redirectUrl) {
                _redirectUrl = process.env.REACT_APP_PUBLIC_SITE;
            }
            setRedirectUrl(_redirectUrl);
        };

        window.addEventListener('message', handleMessage);
        setListeningForMessages(true);
        secondFunction();
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    useEffect(() => {
        if (loggedOutNetworkUi && loggedOutProviderUi && loggedOutIdUi) {
            setLoggedOutComplete(true);
        }
    }, [loggedOutNetworkUi, loggedOutProviderUi, loggedOutIdUi]);

    useEffect(() => {
        if (listeningForMessages) {
            if (loggedOutIdUi) {
                // We will wait for 5 seconds. If we can't clear the caches, then this is likely in development and one of the UI sites is not running
                setTimeout(() => {
                    setLoggedOutComplete(true);
                }, 5000);
            }
        }
    }, [listeningForMessages]);

    useEffect(() => {
        if (loggedOutComplete) {
            const timer = setInterval(() => {
                setCountdown((prevCount) => {
                    if (prevCount <= 1) {
                        clearInterval(timer);
                        window.location.href = redirectUrl;
                    }
                    return prevCount - 1;
                });
            }, 1000);
        }
    }, [loggedOutComplete]);

    const status = () => {
        return (
            <div>
                {loggedOutComplete ? (
                    <h4>Logout Successful</h4>
                ) : (
                    <h4>Logging out...</h4>
                )}
                {loggedOutComplete && (
                    <>
                        <div className='text-lg'>You will be redirected in {countdown} seconds to:</div>
                        <div className='mt-2'>
                            <a href={redirectUrl}>{redirectUrl}</a>
                        </div>
                        <div className="flex justify-content-center mt-3">
                            <Avatar label="or" shape="circle" />
                        </div>
                        <div className='flex flex-row mt-3 justify-content-center'>
                            <div className='flex mr-2'>
                                <a href={process.env.REACT_APP_NETWORK_SITE}>Home</a>
                            </div>
                            <div>
                                |
                            </div>
                            <div className='flex ml-2'>
                                <a href={process.env.REACT_APP_ID_SITE + "/login"}>Login</a>
                            </div>
                        </div>
                    </>
                )}
                {listeningForMessages && (
                    <>
                        <iframe
                            src={process.env.REACT_APP_NETWORK_SITE + "/logout"}
                            style={{ width: 1, height: 1, border: 'none' }}
                        />
                        <iframe
                            src={process.env.REACT_APP_PROVIDER_SITE + "/logout"}
                            style={{ width: 1, height: 1, border: 'none' }}
                        />
                    </>
                )}
            </div>
        );
    }

    const layoutContainerClassName = classNames(
        "layout-wrapper ",
        "pages-body",
        "login-page",
        "flex",
        "flex-column",
        "layout-menu-cyan layout-topbar-cyan",
        {
            "layout-topbar-mobile-active": false,
            "p-input-outlined": "outlined",
        }
    );

    return (
        <div className={layoutContainerClassName}>
            <MainMenu />
            <div className="align-self-center mt-auto mb-auto">
                <div className="pages-panel card flex flex-column p-4">
                    {status()}
                </div>
            </div>
        </div>
    );
};

export default Logout;
